import './Bot.styles.scss';

import { Avatar } from 'primereact/avatar';
import React, { memo, useCallback } from 'react';

import { AvailableBotResponse } from '../../model/availablebot/AvailableBotResponse';
import { Player } from '../../model/Player';
import { copyToClipboard } from '../../utils/keyboard.utils';
import LongText from '../LongText/LongText';
import { BotProps } from './Bot.types';

const Bot = <T extends Player | AvailableBotResponse>({
  bot,
  selected,
  onSelectBot,
}: BotProps<T>): React.ReactElement => {
  const onCopy = useCallback(
    (text: string): void => {
      onSelectBot(bot);
      void copyToClipboard(text);
    },
    [onSelectBot, bot],
  );

  return (
    <div
      className={`Bot-Component cursor-pointer rounded-5 px-3 p-2 text-center${
        selected ? ' active' : ''
      }`}
      onClick={() => onSelectBot(bot)}
    >
      <div className="bot-image d-inline-block border border-2 rounded-circle border-black p-2">
        <Avatar image="/assets/bot.svg" shape="circle" size="xlarge" />
      </div>
      <div className="bot-info p-1">
        <div className="mt-1 mb-2 fw-bold">
          <LongText text={bot.nick} onCopy={onCopy} position="top" />
        </div>
        <div className="my-1">
          <LongText text={bot.pid} onCopy={onCopy} position="top" />
        </div>
      </div>
    </div>
  );
};

export default memo(Bot) as <T extends Player | AvailableBotResponse>(
  props: BotProps<T>,
) => React.ReactElement;
